<template>
  <v-app-bar app flat absolute color="transparent">
    <v-toolbar-title>
      <span class="title font-weight-regular">POI Tracker</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
  </v-app-bar>
</template>

<script>
export default {
  data: () => ({
  }),
};
</script>

<style scoped>
</style>
